import zIndex from "@material-ui/core/styles/zIndex";

export default theme => ({
    formContainer: {
        [theme.breakpoints.up('md')]: {
            padding: '20px 8px 36px 30px'
        }
    }
})